import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isSaving: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    saveStart: (state) => {
      state.isSaving = true;
    },
    saveStop: (state) => {
      state.isSaving = false;
    },
  },
  selectors: {
    isSaving: (state) => state.isSaving,
  },
});

export const actions = uiSlice.actions;
export const uiActions = uiSlice.actions;
export const selectors = uiSlice.selectors;
export const utils = {
  isNumericKeyPress: (e: React.KeyboardEvent | KeyboardEvent) =>
    e.code.startsWith('Digit') || e.code.startsWith('Numpad'),
  isCtrlCKeyPress: (e: React.KeyboardEvent | KeyboardEvent) => e.key === 'c' && (e.ctrlKey || e.metaKey), // win / mac
  isCtrlVKeyPress: (e: React.KeyboardEvent | KeyboardEvent) => e.key === 'v' && (e.ctrlKey || e.metaKey), // win / mac
};

export default uiSlice.reducer;
